import { render, staticRenderFns } from "./Component4.vue?vue&type=template&id=59468149&scoped=true&"
import script from "./Component4.vue?vue&type=script&lang=js&"
export * from "./Component4.vue?vue&type=script&lang=js&"
import style0 from "./Component4.vue?vue&type=style&index=0&id=59468149&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59468149",
  null
  
)

export default component.exports